/**
 * 上报WebRTC调用信息
 * @param {Object} rtcData - 从RTCPeerConnection获取的数据
 */
export function reportRtcCall(rtcData) {

	if (!rtcData) {
		return
	}

	// 抽样率控制上报流量 (1% sample rate)
	// const shouldReport = Math.random() < 0.01
	// if (!shouldReport) {
	// 	console.log('WebRTC report skipped due to sampling')
	// 	return
	// }

	const data = {
		dt: new Date().toISOString().split('T')[0],
		host: window.location.hostname,
		path: window.location.pathname,
		timestamp: Date.now(),
		// As requested, putting RTC data into `injectedScripts` field
		injectedScripts: [rtcData],
		scriptCount: 1,
	}

	// 使用fetch发送数据到后端
	fetch('https://data-tr.videodownloader.software/web/report', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})
		.then((response) => {
			console.log('WebRTC report sent successfully', response.status)
		})
		.catch((error) => {
			console.error('Error reporting WebRTC call:', error)
		})
}
